module.exports = __webpack_public_path__ + "img/ser8.d24b4ef5.png";